/* global fetch */
import 'whatwg-fetch'
import config from '../../config'

const { REACT_APP_ENV } = config;


const baseHeaders = {}
const prodHeaders = { 'X-Api-Key': '8zJ81BXvr9aZgbusqu4J6136fSlGJwnOa9nnCY4S' }
const devHeaders = { 'X-Api-Key': 'Z3iq6XAoP5629Wr6LBZ5q7pdh6YlXBdL5zb9cMTz' }

const defaultHeaders =
  REACT_APP_ENV === 'production'
    ? { ...baseHeaders, ...prodHeaders }
    : { ...baseHeaders, ...devHeaders }
// : { ...baseHeaders, ...prodHeaders }

export const checkStatus = response => {
  if (!response.error) {
    return response
  }

  const error = new Error(response.error.message)
  error.response = response
  // reject instead
  throw error
}

export const parseJSON = response => response.json()

export const fetchResource = (
  url,
  { headers = {}, method = 'GET', body } = {}
) =>
  fetch(url, {
    method: method || 'GET',
    body: body && JSON.stringify(body),
    credential: 'include',
    headers: { ...defaultHeaders, ...headers }
  })
    .then(parseJSON)
    .then(checkStatus)

export const postResource = (url, { headers = {}, body } = {}) =>
  fetchResource(url, {
    headers: { 'Content-Type': 'application/json', ...headers },
    method: 'POST',
    body
  })



// WEBPACK FOOTER //
// ./src/shared/utils/fetchUtils.js